import styled from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';

const Link = styled.a`
  color: ${rgba(cFFFFFF, 0.7)};
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: ${cFFFFFF};
  }
`;

export default Link;
